import _ from "lodash";
import {
  Component,
} from "react";

import store from "CommonState/store";
import {
  Alert,
  Button,
  Modal,
} from "react-bootstrap";
import {
  ChangeOnTypeFormControl,
} from "CommonComponents/detail-view";

@store("currentMassnahmeInflight")
export default class AntragStatuswechselPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { onClose, zielstatus } = this.props;
    const { errorMessage } = this.state;

    const schema = { field: "grund", display: "Grund für den Statuswechsel", hint: "Bitte geben Sie einen Grund ein" };

    return (

      <Modal show onHide={onClose}>
        <Modal.Header>
          Status wechseln und Grund angeben
        </Modal.Header>
        <Modal.Body>
          {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}

          <h3>{`Sind sie sicher, dass Sie den Status '${ zielstatus.asf_kbez }' setzen möchten?`}</h3>
          <br />
          <p>Bitte geben Sie in diesem Fall einen Grund ein, der als Notiz am Antrag gespeichert wird.</p>
          <br />

          <ChangeOnTypeFormControl
            id={"text" }
            entity={this.state}
            schema={schema}
            onChange={this.onChange}
          />

        </Modal.Body>
        <Modal.Footer>
          <Button variant='primary' onClick={this.onConfirm} disabled={_.isEmpty((this.state.grund || "").trim())}>
            {zielstatus.asf_kbez}
          </Button>
          <Button variant='link' onClick={this.onCancel} >Schließen</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  onChange = (fld, value) => {
    this.setState({ grund: value });
  };

  onConfirm = () => {
    this.props.onClose(this.state.grund);
  };
  onCancel = () => {
    this.props.onCancel();
  };
}

